import { Component, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { switchMap, mapTo, startWith, scan, takeWhile, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-number-tracker',
  templateUrl: './number-tracker.component.html',
  styleUrls: ['./number-tracker.component.scss'],
})
export class NumberTrackerComponent implements OnDestroy {

  @Input()
  set target(target: number) {
    this._counterSub$.next(target);
  }
  @Input() countInterval = 20;
  @Input() factor = 10;
  public currentNumber = 0;
  private _counterSub$ = new BehaviorSubject(0);
  private _onDestroy$ = new Subject();
  private left = 0;

  constructor() {
    this._counterSub$
      .pipe(
        switchMap(target => {
          return timer(0, this.countInterval).pipe(
            mapTo(this.positiveOrNegative(target, this.currentNumber)),
            startWith(this.currentNumber),
            scan((acc: number, curr: number) => acc + curr * this.factor),
            takeWhile(this.isApproachingRange(target, this.currentNumber))
          )
        }),
        takeUntil(this._onDestroy$)
      )
      .subscribe((val: number) => {
        let target = this._counterSub$.getValue();
        this.left = target % this.factor;
        this.currentNumber = val;
        if (Math.abs(target - this.currentNumber) === this.left) {
          this.currentNumber = this.currentNumber + this.left;
        }
      });
  }

  private positiveOrNegative(target, currentNumber) {
    return target > currentNumber ? 1 : -1;
  }

  private isApproachingRange(target, currentNumber) {
    return target > currentNumber
      ? val => val <= target
      : val => val >= target;
  }

  ngOnDestroy(): void {
    this._onDestroy$.next(true);
    this._onDestroy$.complete();
  }

}
